import { BUTTON_SIZE, BUTTON_TYPE, COLORS, DSButton, DSModal } from '@repo/design-system/index'
import { QIcon_enter_profile } from '@repo/icons/index'
import { useAITutorSummaryMembership } from '../../../modules/apis/student/ai-tutor'
import { APP_SCREEN_NAME } from '../../../modules/hooks/common/appRouterVars'
import useAppRouter, { sendRouterEvent } from '../../../modules/hooks/common/useAppRouter'
import useIsWebview from '../../../modules/hooks/common/useIsWebview'
import useReturnFullUrl from '../../../modules/hooks/webview/common/useReturnFullUrl'
import { n_ai_speaking, n_ai_tutor, n_common } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import urls from '../../../modules/urls'
import { useAITutorStack } from '../../../pages/[lang]/webview/ai-tutor'
export const AITutorPopupNoCreditB2B = ({ show, setShow }) => {
  const { t } = useTranslation()

  return (
    <DSModal id="aiTutorNoCredit" isOpen={show} setIsOpen={setShow} size={'sm'} closeButton={false}>
      <DSModal.Title className="keep-all">{t(n_ai_tutor.popup.b2b_title1)}</DSModal.Title>
      <DSModal.Content className="mt-[16px]">{t(n_ai_tutor.popup.b2b_body1)}</DSModal.Content>
      <DSModal.ButtonContainer direction="horizontal">
        <DSButton
          size={BUTTON_SIZE.MD}
          type={BUTTON_TYPE.SOLID}
          onClick={() => {
            setShow(false)
          }}
        >
          <DSButton.Label>{t(n_common.btn_ok)}</DSButton.Label>
        </DSButton>
      </DSModal.ButtonContainer>
    </DSModal>
  )
}

export const AITutorQuitComfirm = ({ show, setShow }) => {
  const { t } = useTranslation()
  const { useAITutorFlow } = useAITutorStack()
  const { push } = useAITutorFlow()
  const router = useAppRouter({ stackPush: push, browserDetect: true })
  const getFullUrl = useReturnFullUrl()
  const isWebview = useIsWebview()

  const routerMoveListPage = () => {
    if (isWebview) {
      router.replace(urls.webview.aiTutor.index(), {
        appScreenName: APP_SCREEN_NAME.AI_TUTOR_SCREEN,
        appSendData: {
          url: getFullUrl(urls.webview.aiTutor.index()),
        },
      })
    } else {
      router.push(urls.webview.aiTutor.index(), {
        appScreenName: APP_SCREEN_NAME.AI_TUTOR_SCREEN,
        appSendData: {
          url: getFullUrl(urls.webview.aiTutor.index()),
        },
      })
    }
    sendRouterEvent({
      nav: APP_SCREEN_NAME.AI_TUTOR_SCREEN,
    })
  }

  return (
    <DSModal id="aiTutorQuitConfirm" isOpen={show} setIsOpen={setShow} size={'sm'} closeButton={false}>
      <DSModal.Title className="keep-all">{t(n_ai_tutor.study_activity.popup_title)}</DSModal.Title>
      <DSModal.Content className="mt-[16px]">{t(n_ai_tutor.study_activity.popup_body)}</DSModal.Content>
      <DSModal.ButtonContainer direction="horizontal">
        <DSButton
          size={BUTTON_SIZE.MD}
          type={BUTTON_TYPE.OUTLINE}
          onClick={() => {
            setShow(false)
          }}
        >
          <DSButton.Label>{t(n_ai_tutor.study_activity.popup_btn1)}</DSButton.Label>
        </DSButton>
        <DSButton
          size={BUTTON_SIZE.MD}
          type={BUTTON_TYPE.SOLID}
          onClick={() => {
            setShow(false)
            routerMoveListPage()
          }}
        >
          <DSButton.Label>{t(n_ai_tutor.study_activity.popup_btn2)}</DSButton.Label>
        </DSButton>
      </DSModal.ButtonContainer>
    </DSModal>
  )
}

export const AITutorNoCaf = ({ show, setShow, setTabId }) => {
  const { data: aiTutorMembershipData } = useAITutorSummaryMembership('curriculum')
  const { t } = useTranslation()
  const { useAITutorFlow } = useAITutorStack()
  const { push } = useAITutorFlow()
  const router = useAppRouter({ stackPush: push, browserDetect: true })
  const getFullUrl = useReturnFullUrl()

  const onEnter = () => {
    if (aiTutorMembershipData?.is_trial) {
      const url = urls.webview.aiTutor.purchase
      router.push(url, {
        appScreenName: APP_SCREEN_NAME.IAP_SCREEN,
        appSendData: { url: getFullUrl(url) },
      })
    } else {
      setTabId(1)
    }
  }

  return (
    <DSModal id="aiTutorQuitConfirm" isOpen={show} setIsOpen={setShow} size={'sm'} closeButton={false}>
      <DSModal.Title className="keep-all">{t(n_ai_tutor.acheivement.popup_title)}</DSModal.Title>
      <DSModal.Content className="mt-[16px]">
        {t(aiTutorMembershipData?.is_trial ? n_ai_tutor.acheivement.popup_body3 : n_ai_tutor.acheivement.popup_body2)}
      </DSModal.Content>
      <DSModal.ButtonContainer direction="horizontal">
        <DSButton
          size={BUTTON_SIZE.MD}
          type={BUTTON_TYPE.OUTLINE}
          onClick={() => {
            setShow(false)
          }}
        >
          <DSButton.Label>{t(n_common.btn_cancel)}</DSButton.Label>
        </DSButton>
        <DSButton
          size={BUTTON_SIZE.MD}
          type={BUTTON_TYPE.SOLID}
          onClick={() => {
            setShow(false)
            onEnter()
          }}
        >
          <DSButton.Label>
            {t(aiTutorMembershipData?.is_trial ? n_ai_tutor.acheivement.btn5 : n_ai_tutor.acheivement.btn4)}
          </DSButton.Label>
        </DSButton>
      </DSModal.ButtonContainer>
    </DSModal>
  )
}

export const AITutorFillProfileRequest = ({ show, setShow }) => {
  const { t } = useTranslation()
  const { useAITutorFlow } = useAITutorStack()
  const { push } = useAITutorFlow()
  const router = useAppRouter({ stackPush: push, browserDetect: true })
  const getFullUrl = useReturnFullUrl()

  const onClickProfile = () => {
    router.push(urls.webview.aiTutor.jobSelect, {
      appScreenName: APP_SCREEN_NAME.STACK_SCREEN,
      appSendData: { url: getFullUrl(urls.webview.aiTutor.jobSelect) },
    })
  }

  return (
    <DSModal id="aiTutorFillProfileRequest" isOpen={show} setIsOpen={setShow} size={'sm'} closeButton={false}>
      <DSModal.Title className="keep-all">{t(n_ai_tutor.popup.profile_title)}</DSModal.Title>
      <DSModal.Content className="mt-[16px]">
        <QIcon_enter_profile width={'100%'} height="142px" />
      </DSModal.Content>
      <DSModal.ButtonContainer direction="horizontal">
        <DSButton
          size={BUTTON_SIZE.MD}
          type={BUTTON_TYPE.OUTLINE}
          onClick={() => {
            setShow(false)
          }}
        >
          <DSButton.Label>{t(n_ai_tutor.popup.profile_btn1)}</DSButton.Label>
        </DSButton>
        <DSButton
          size={BUTTON_SIZE.MD}
          type={BUTTON_TYPE.SOLID}
          onClick={() => {
            setShow(false)
            onClickProfile()
          }}
        >
          <DSButton.Label>{t(n_ai_tutor.popup.profile_btn2)}</DSButton.Label>
        </DSButton>
      </DSModal.ButtonContainer>
    </DSModal>
  )
}

export const ThreadContinuePopup = ({ continueThreadModal, setContinueThreadModal, handleContinue, handleNew }) => {
  const { t } = useTranslation()
  //DS modal 말고..

  // return (
  //   <TransitionsModal
  //     open={continueThreadModal}
  //     onClose={() => setContinueThreadModal(false)}
  //     title="Modal Title"
  //     description="설명 텍스트 들어가는 부분"
  //   >
  //     <DSModal.Title className="keep-all">{t(n_ai_speaking.popup_ongoing.title)}</DSModal.Title>
  //     <DSModal.Content className="mt-[16px]">{t(n_ai_speaking.popup_ongoing.body)}</DSModal.Content>
  //     <DSModal.ButtonContainer direction="vertical">
  //       {/* 대화 이어서 하기 */}
  //       <DSButton size={BUTTON_SIZE.MD} type={BUTTON_TYPE.SOLID} onClick={handleContinue}>
  //         <DSButton.Label>{t(n_ai_speaking.popup_ongoing.btn2)}</DSButton.Label>
  //       </DSButton>

  //       {/* 새로운 대화 시작하기 */}
  //       <DSButton
  //         size={BUTTON_SIZE.MD}
  //         type={BUTTON_TYPE.SOLID}
  //         customBgColor="#FFFFFF"
  //         onClick={() => {
  //           setContinueThreadModal(false)
  //           handleNew()
  //         }}
  //       >
  //         <DSButton.Label customTxtColor={COLORS.BLACK}>{t(n_ai_speaking.popup_ongoing.btn1)}</DSButton.Label>
  //       </DSButton>
  //     </DSModal.ButtonContainer>
  //   </TransitionsModal>
  // )

  return (
    <DSModal
      id="continueConversationModal"
      isOpen={continueThreadModal}
      setIsOpen={setContinueThreadModal}
      size={'sm'}
      closeButton={true}
    >
      <DSModal.Title className="keep-all">{t(n_ai_speaking.popup_ongoing.title)}</DSModal.Title>
      <DSModal.Content className="mt-[16px]">{t(n_ai_speaking.popup_ongoing.body)}</DSModal.Content>
      <DSModal.ButtonContainer direction="vertical">
        {/* 대화 이어서 하기 */}
        <DSButton size={BUTTON_SIZE.MD} type={BUTTON_TYPE.SOLID} onClick={handleContinue}>
          <DSButton.Label>{t(n_ai_speaking.popup_ongoing.btn2)}</DSButton.Label>
        </DSButton>

        {/* 새로운 대화 시작하기 */}
        <DSButton
          size={BUTTON_SIZE.MD}
          type={BUTTON_TYPE.SOLID}
          customBgColor="#FFFFFF"
          onClick={() => {
            setContinueThreadModal(false)
            handleNew()
          }}
        >
          <DSButton.Label customTxtColor={COLORS.BLACK}>{t(n_ai_speaking.popup_ongoing.btn1)}</DSButton.Label>
        </DSButton>
      </DSModal.ButtonContainer>
    </DSModal>
  )
}

export const ConversationQuestionPopup = ({ show, setShow, handleStart }) => {
  const { t } = useTranslation()

  return (
    <DSModal id="ConversationQuestionPopup" isOpen={show} setIsOpen={setShow} size={'sm'} closeButton={false}>
      <DSModal.Title className="keep-all">{t(n_ai_tutor.discussion_question.popup_title)}</DSModal.Title>
      <DSModal.Content className="mt-[16px]">{t(n_ai_tutor.discussion_question.popup_desc)}</DSModal.Content>
      <DSModal.ButtonContainer direction="horizontal">
        <DSButton size={BUTTON_SIZE.MD} type={BUTTON_TYPE.OUTLINE} onClick={() => setShow(false)}>
          <DSButton.Label>{t(n_ai_tutor.discussion_question.btn_2)}</DSButton.Label>
        </DSButton>
        <DSButton size={BUTTON_SIZE.MD} type={BUTTON_TYPE.SOLID} onClick={handleStart}>
          <DSButton.Label>{t(n_ai_tutor.discussion_question.btn_1)}</DSButton.Label>
        </DSButton>
      </DSModal.ButtonContainer>
    </DSModal>
  )
}
